import { useState } from 'react';
import { Button } from "react-bootstrap";
//import { getAuth,sendPasswordResetEmail } from 'firebase/auth';
//import { auth } from '../firebase';
import styles from './ForgottenPassword.css';
import { useNavigate, Link } from 'react-router-dom';
import { AiFillEye } from "react-icons/ai";
import { AiFillEyeInvisible } from "react-icons/ai";
//import { getFirebaseApp } from '../utils/firebaseHelper'
//import { ref, child, set, getDatabase } from 'firebase/database'
import Konsensus_Constants from '../constants/index.js';
import axios from "axios";
import { useSearchParams } from "react-router-dom";

export default function ForgottenPassword() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email");
  const token = searchParams.get("token");
  const [password, setPassword] = useState('');
  console.log(token);

  const handleResetPassword = async () => {
      const formData = new URLSearchParams();
      formData.append('email', email);
      formData.append('token', token);
      formData.append('password', password);
      let xcsrftoken = '';
      try {
        const response = await fetch(Konsensus_Constants.FORUM_URL+'/api/reset-password', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ token: token, password: password }),
        });

        // You can check response.status
        console.log(response);
        console.log(response.status);
        if (response.status===200) {
            let response2 = await axios.post(Konsensus_Constants.NEM_URL+'/NEM/api/api.php/set-password', {email: email, password: password,
                token: token}, Konsensus_Constants.AXIOS_CONFIG);
            if( response2.error ){
                alert(response2.error);
            }else{
                alert('Password change successful');
            }
        } else {
          alert('There was an error processing your request.');
        }
      } catch (error) {
        alert('Network error, please try again.');
        console.log(error);
      }
  };

  return (
  <div style={{
                height: '100%',
                display: 'grid',
                placeItems: 'center',
              }}>
    <div style={{
                  flex: 1,
                  align: 'center',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginHorizontal: 22,
                }}>
      <img
         src={require('../assets/images/logo.png')}
         style={{
            height: 240,
            width: 340,
            marginBottom: 12,
         }}
      />
      <h2>Reset Password</h2>
      <div><input placeholder="Password" className="input-rounded" type="password"
        onChange={e => setPassword(e.target.value)} /></div>
      <Button onClick={handleResetPassword} style={{backgroundColor: "#00aaaf", borderColor: "#00aaaf"}} className="input-rounded">Reset password</Button>
      <p>Already have an account? <Link to="/">Login</Link></p>
    </div>
  </div>
  );
}